import React from "react";

// props
import * as H from "history";
import { SupportPlanState } from "@stores/domain/mgr/SHUROTEICHAKU/supportPlan/types";
import { RecordUserDetailState } from "@stores/pages/record/userDetail/types";
import {
  createStyles,
  withStyles,
  WithStyles,
  StyleRules
} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { PlanList } from "@components/organisms/mgr/SHUROTEICHAKU/record/PlanList";

// ui
import NoRecord from "@components/organisms/mgr/common/record/NoRecord";
import { UserState } from "@stores/domain/user/type";
import { ErrorsState } from "@stores/domain/errors/types";
import { RecordHeaderLinkButtonType } from "@components/organisms/mgr/SHUROTEICHAKU/record/RecordHeaderLinkButtonType";

const styles = (): StyleRules =>
  createStyles({
    root: {
      padding: 32
    }
  });

type OwnProps = {
  pageName: string;
  userName: string;
  uifId: string;
  supportPlanRecord: SupportPlanState["supportPlan"];
  user: UserState;
  recordUserDetail: RecordUserDetailState;
  planErrors: ErrorsState["plan"]["data"];
  goalErrors: ErrorsState["goal"]["data"];
  history: H.History;
  year: string;
  month: string;
};

type Props = OwnProps & WithStyles<typeof styles>;

/**
 * 個別支援計画
 */
const SupportPlanRecordListCore = (props: Props): JSX.Element | null => {
  const ids: number[] = [];
  const periodData: SupportPlanState["supportPlan"] = [];
  const outPeriodData: SupportPlanState["supportPlan"] = [];

  if (!props.supportPlanRecord) return null;
  props.supportPlanRecord.forEach((supportPlan) => {
    const planCreateCheck =
      ids.indexOf(supportPlan.id) === -1 && supportPlan.id !== 0;
    if (!supportPlan.archive && planCreateCheck) {
      ids.push(supportPlan.id);
      periodData.push(supportPlan);
    } else if (planCreateCheck) {
      ids.push(supportPlan.id);
      outPeriodData.push(supportPlan);
    }
  });

  const onClickPlanDoc = (planId: number) => (): void => {
    const url = `/record/${props.uifId}/support_plan/${planId}`;
    props.history.push(url);
  };

  const onClickPlanEvaluationDoc = (planId: number) => (): void => {
    const url = `/record/${props.uifId}/support_plan/evaluation/${planId}`;
    props.history.push(url);
  };

  const onClickCopy = (planId: number) => (): void => {
    const url = `/record/${props.uifId}/support_plan/${planId}/copy`;
    props.history.push(url);
  };

  let noRecordMessage = "";
  if (
    !props.supportPlanRecord ||
    props.supportPlanRecord.length === 0 ||
    props.supportPlanRecord[0].id === 0
  ) {
    noRecordMessage =
      "個別支援計画書がありません。新規作成ボタンから作成してください。";
  }
  const hasRecord = noRecordMessage === "";

  return (
    <>
      <RecordHeaderLinkButtonType
        pageName={props.pageName}
        userName={props.userName}
        hasRecord // ボタンを表示するかどうかを見ているので無条件にtrueを渡す
        uifId={props.uifId}
        year={props.year}
        month={props.month}
        recordType="support_plan"
        isEditing={props.recordUserDetail.isEditing}
        history={props.history}
      />
      {hasRecord ? (
        <Paper className={props.classes.root} elevation={0}>
          {periodData.length > 0 && (
            <PlanList
              targetPlans={periodData}
              user={props.user}
              planErrors={props.planErrors}
              goalErrors={props.goalErrors}
              handleClickPlanDoc={onClickPlanDoc}
              handleClickPlanEvaluationDoc={onClickPlanEvaluationDoc}
              handleClickCopy={onClickCopy}
            />
          )}
          {outPeriodData.length > 0 && (
            <PlanList
              planTitle="過去の計画書"
              targetPlans={outPeriodData}
              user={props.user}
              planErrors={props.planErrors}
              goalErrors={props.goalErrors}
              handleClickPlanDoc={onClickPlanDoc}
              handleClickPlanEvaluationDoc={onClickPlanEvaluationDoc}
              handleClickCopy={onClickCopy}
            />
          )}
        </Paper>
      ) : (
        <NoRecord message={noRecordMessage} />
      )}
    </>
  );
};

export const SupportPlanRecordList = withStyles(styles)(
  SupportPlanRecordListCore
);
